import classNames from "classnames";
import React from "react";
import BlokWithBorderIcons from "../../../interfaces/Storyblok/BlokWithBorderIcons.interface";
import StoryblokTable, { StoryblokTableData } from "./StoryblokTable";

interface SampleFeesTableProps extends BlokWithBorderIcons {
  pre_header_text_colour: string;
  header_text_colour: string;
  odd_row_text_colour: string;
  even_row_text_colour: string;

  pre_header_bg_colour: string;
  header_bg_colour: string;
  odd_row_bg_colour: string;
  even_row_bg_colour: string;

  header: string;
  left_table_header: string;
  right_table_header: string;

  left_table: StoryblokTableData;
  right_table: StoryblokTableData;
}

const SampleFeesTable: React.FC<SampleFeesTableProps> = ({
  pre_header_text_colour,
  header_text_colour,
  odd_row_text_colour,
  even_row_text_colour,
  pre_header_bg_colour,
  header_bg_colour,
  odd_row_bg_colour,
  even_row_bg_colour,
  header,
  left_table_header,
  right_table_header,
  left_table,
  right_table,
}) => {
  return (
    <div className="container mx-auto" id="">
      <div className="py-20">
        {header && (
          <h2 className="text-xl md:text-2xl xl:text-3xl 3xl:text-4xl font-extrabold font-secondary text-Primary-900 text-center pb-10 sm:pb-14">
            {header}
          </h2>
        )}

        <div
          className={classNames({
            "space-y-12 sm:space-y-20": left_table && right_table,
          })}
        >
          <>
            {left_table && (
              <StoryblokTable
                tableData={left_table}
                pre_headers={[left_table_header]}
                header_bg_colour={header_bg_colour}
                header_text_colour={header_text_colour}
                even_row_bg_colour={even_row_bg_colour}
                odd_row_bg_colour={odd_row_bg_colour}
                pre_header_text_colour={pre_header_text_colour}
                odd_row_text_colour={odd_row_text_colour}
                even_row_text_colour={even_row_text_colour}
                pre_header_bg_colour={pre_header_bg_colour}
              />
            )}
            {right_table && right_table_header && (
              <StoryblokTable
                tableData={right_table}
                pre_headers={[right_table_header]}
                header_bg_colour={header_bg_colour}
                header_text_colour={header_text_colour}
                even_row_bg_colour={even_row_bg_colour}
                odd_row_bg_colour={odd_row_bg_colour}
                pre_header_text_colour={pre_header_text_colour}
                odd_row_text_colour={odd_row_text_colour}
                even_row_text_colour={even_row_text_colour}
                pre_header_bg_colour={pre_header_bg_colour}
              />
            )}
          </>
        </div>
      </div>
    </div>
  );
};
export default SampleFeesTable;
